import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { Link } from 'react-router';
import { msg } from 'api';

import Button from 'widgets/Button';
import Input from 'widgets/Input/Input';
import Radio from 'widgets/Radio/Radio';
import Rating from 'widgets/Rating/Rating';

import { findErrorMessageForField } from 'apps/products/utils/createReview';

const NICKNAME_REJECTED = 'REJECTED';

export default class CreateReviewAddReview extends PureComponent {
  static propTypes = {
    sku: PropTypes.string.isRequired,
    customerNickname: PropTypes.shape({
      nickname: PropTypes.string.isRequired,
      status: PropTypes.string.isRequired,
    }),
    rating: PropTypes.number,
    recommended: PropTypes.bool,
    newNickname: PropTypes.string,
    validationErrors: PropTypes.array,
    updateFields: PropTypes.func.isRequired,
    postReview: PropTypes.func.isRequired,
    displayAddDetailsForm: PropTypes.func.isRequired,
    validateNickname: PropTypes.func.isRequired,
    onSave: PropTypes.func.isRequired,
    setNickname: PropTypes.func.isRequired,
    termsOfUseLink: PropTypes.string,
    termsOfUseLinkText: PropTypes.string,
    termsOfUseText: PropTypes.string,

  };

  static defaultProps = {
    validationErrors: [],
  };

  state = {
    isRejected: this.props.customerNickname && this.props.customerNickname.status === NICKNAME_REJECTED,
  };

  areButtonsAvailable = () =>
    this.props.rating > 0
    && this.isNicknameSortedOut()
    && this.props.recommended !== null;

  updateConsentState = (event) => {
    const {
      value,
    } = event.target;
    this.props.updateFields({ recommended: !!parseInt(value, 10) });
  };

  updateRating = (rating) => {
    this.props.updateFields({ rating });
  };

  updateNickname = (name, value) => {
    const validationErrors = this.props.validationErrors.filter((item) => item.field !== 'newNickname');
    this.setState({ isRejected: false });
    this.props.updateFields({ newNickname: value, validationErrors });
  };

  shouldShowNickname = () => {
    const { customerNickname: { status, nickname } = {} } = this.props;
    return !nickname || (nickname && status === NICKNAME_REJECTED);
  };

  postReview = () => {
    const { sku, rating, recommended, newNickname } = this.props;
    this.props.postReview(sku, {
      rating,
      recommended,
      termAgreed: true,
      customerNickname: newNickname && newNickname.trim(),
    }).then((isValid) => {
      if (!isValid) {
        return;
      }
      if (newNickname) {
        this.props.setNickname({ nickname: newNickname, status: 'PENDING' });
      }
      this.props.onSave();
    });
  };

  validateNickname = (callback) => {
    const { customerNickname: { nickname, status } = {}, newNickname } = this.props;
    if (nickname && status !== NICKNAME_REJECTED) {
      return callback();
    }

    return this.props.validateNickname(newNickname).then((isValid) => {
      if (isValid) {
        callback();
      }
    });
  };

  handleSubmit = () => {
    this.validateNickname(this.postReview);
  };

  handleAddDetails = () => {
    this.validateNickname(this.props.displayAddDetailsForm);
  };

  isNicknameSortedOut = () =>
    !(this.shouldShowNickname()
      && (!this.props.newNickname
        || this.props.newNickname.length < 1
        || findErrorMessageForField(this.props.validationErrors, 'newNickname')
      ));

  render() {
    const {
      rating,
      validationErrors,
      customerNickname: { nickname } = {},
      termsOfUseLink = 'N/A',
      termsOfUseLinkText = 'Terms & Conditions',
      termsOfUseText = 'By leaving a review you confirm you accept our',
    } = this.props;
    const areButtonsAvailable = this.areButtonsAvailable();

    return (
      <>
        <div className="bop-review__grayField">
          <span className="bop-review__ratingLabel">
            Rating:
            <span className="gn-fieldLabel__requiredMark">&nbsp;*</span>
          </span>
          <Rating
            active
            large
            reviewStats={{ averageRate: rating }}
            onChange={this.updateRating}
          />
          <p className="bop-review__reccomendationLabel">
            Would you recommend this product to a friend?
            <span className="gn-fieldLabel__requiredMark">
              &nbsp;*
            </span>
          </p>
          <div className="bop-review__recommendationWrapper">
            <Radio
              label="Yes"
              name="recommended"
              value="1"
              id="Yes"
              onChange={this.updateConsentState}
            />
            <Radio
              label="No"
              name="recommended"
              value="0"
              id="No"
              onChange={this.updateConsentState}
            />
          </div>
        </div>

        {this.shouldShowNickname() && (
          <>
            {this.state.isRejected && (
              <p className="bop-review__rejectedNickname">
                Sorry your nickname has been rejected. Please enter new nickname.
              </p>
            )}
            <Input
              id="newNickname"
              name="newNickname"
              type="text"
              label="Your nickname:"
              required
              defaultValue={nickname}
              className={classNames({ 'gn-input__field--invalid': this.state.isRejected })}
              onChange={this.updateNickname}
              placeholder="Min. of 2 characters and a max. of 28 characters"
              errorMessage={findErrorMessageForField(validationErrors, 'newNickname')}
              infoMessage={msg.reviews.nicknameInfo}
            />
          </>
        )}

        <span>
          {termsOfUseText}
          <Link className="bop-review__termsAnd" to={termsOfUseLink} target="_blank">{termsOfUseLinkText}</Link>
        </span>
        <div className="bop-review__buttonsWrapper">
          <Button
            className="bop-review__submitWithoutDetails"
            secondary
            disabled={!areButtonsAvailable}
            onClick={this.handleSubmit}
          >
            Save
          </Button>

          <Button
            className="bop-review__addReviewButton"
            primary
            disabled={!areButtonsAvailable}
            onClick={this.handleAddDetails}
          >
            Add review
          </Button>
        </div>
      </>
    );
  }
}
